import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import FeedItem from './FeedItem/FeedItem';

import Http from 'Demora/http';

import './Feed.scss';

import NewPostBox from './Posts/NewPostBox';

import socialHttp from '../../../../utils/socialHttp';

import Loading from 'Demora/Loading';

import { areFeelsLoaded } from '../GetFeels';

import FeedSecondColumn from 'resources/assets/react-app/uiHooks/react-social/FeedSecondColumn';

const number_records = 20;

class Feed extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			toggleToolTipPostAge: {},
		};

		this.uniqueID = 'post_age' + '-a' + new Date().getTime();
	}

	showMoreFeed = () => {
		const props = this.props;

		const obj = props.obj;

		const startCursor = props.feed[obj].i.startCursor;

		const ce = new CustomEvent('react_social_click_on_show_more_posts', {
			view: window,
			bubbles: true,
			detail: {
				pid: props.feed[obj].h,
			},
		});

		document.dispatchEvent(ce);

		socialHttp(
			'get',
			'/data/feed/' +
				obj +
				'?limit=' +
				number_records +
				'&before=' +
				startCursor
		).catch((e) => {
			throw e;
		});
	};

	togglePostAge(post) {
		let t = this.state.toggleToolTipPostAge;

		t[post] = !t[post];

		this.setState({
			toggleToolTipPostAge: t,
		});
	}

	getExtraPost(exp) {
		let pid = exp.pid;

		let pidRoot = pid.split('-').slice(0, 2).join('-');

		let pidObj = pid.split('-').slice(0, 3).join('-');

		let ex_p = Object.assign({}, this.props.feed[pidRoot].p[pidObj]);

		ex_p.title = exp.title;

		return ex_p;
	}

	render() {
		const { obj, feed, user } = this.props;

		let thisFeed = this.props.feed[obj];

		let p = thisFeed.p;

		if (!areFeelsLoaded() || !p || !thisFeed.posts) {
			return (
				<div
					className='card panel-white post panel-shadow text-center'
					style={{ padding: '30px 0' }}
				>
					<Loading />
				</div>
			);
		}

		let that = this;

		let showPostBox =
			!obj ||
			user.id + '-u' == obj ||
			(obj.split('-')[1] == 'g' && thisFeed.role > 0)
				? 1
				: 0;

		let itemsToDisplay = [];

		var left = [];

		var right = [];

		let c = 0;

		itemsToDisplay = Object.keys(thisFeed.posts)
			.filter((a) => {
				return p[a] && !p[a].d && !p[a].shared;
			})
			.sort((a, b) => {
				if (p[a].t == p[b].t) {
					return 0;
				}

				return p[a].t < p[b].t ? 1 : -1;
			})
			.map((pp, i) => {
				c++;

				let post = p[pp];

				if (post.d == 1) {
					return '';
				}

				let postId = post.id;

				if (!postId) {
					Http.post('/data/log_error', {
						stacktrace: pp + ' ' + JSON.stringify(post).substring(0, 1000),
						url: window.location.href,
						type: 'postID on feed is undefined',
					}).catch((e) => {
						throw e;
					});
				}

				let obj = postId.split('-').slice(0, 2).join('-');

				let uid = post.u + '-u';

				if (thisFeed.z && thisFeed.z[c]) {
					let exp = this.getExtraPost(thisFeed.z[c]);

					left.push(<FeedItem post={exp} key={'z-' + c} />);

					c++;
				}

				left.push(
					<FeedItem
						post={post}
						obj={this.props.obj}
						key={post.h + '-' + post.id}
					/>
				);
			});

		let next = thisFeed.i.total - itemsToDisplay.length;

		return (
			<div className='row'>
				{thisFeed.z && thisFeed.z[0] && (
					<div className='feed-col-left col-12 col-lg-6'>
						<FeedItem post={this.getExtraPost(thisFeed.z[0])} key={'z-0'} />
					</div>
				)}

				<div className='feed-col-left col'>
					{!!showPostBox && <NewPostBox obj={obj} />}

					{itemsToDisplay.length == 0 && (
						<div
							className='card panel-white post panel-shadow text-center'
							style={{ padding: '30px 0' }}
						>
							There is nothing to see here
						</div>
					)}

					{itemsToDisplay.length > 0 && left}

					<div className='text-center'>
						{itemsToDisplay.length > 0 &&
							(next > 0 ? (
								<button
									className='btn btn-primary btn-small'
									onClick={this.showMoreFeed}
								>
									Show more posts
								</button>
							) : (
								'No more posts to see'
							))}
					</div>
				</div>

				<FeedSecondColumn obj={obj} />
			</div>
		);
	}
}

export default ReduxConnect(Feed, {
	user: 'user',
	users: 'users',
	feels: 'feels',
	feed: 'feed',
});
